module.exports = __webpack_public_path__ + "static/media/receipt_not_found.5057cf99.gif";